var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_62bc672ce0fa1d23adf660f4_check-green-icon",
    "data-name": "62bc672ce0fa1d23adf660f4_check-green-icon",
    d: "M12.545.839l.1.193.727,1.936a.562.562,0,0,0,.33.33l1.869.7a1.691,1.691,0,0,1,1.043,2.013l-.053.164L15.689,8.1a.563.563,0,0,0,0,.467l.826,1.818a1.692,1.692,0,0,1-.687,2.159l-.193.1L13.7,13.37a.565.565,0,0,0-.328.33l-.7,1.869a1.692,1.692,0,0,1-2.014,1.043l-.164-.053L8.567,15.69a.563.563,0,0,0-.467,0l-1.817.826a1.692,1.692,0,0,1-2.159-.687l-.1-.193L3.3,13.7a.565.565,0,0,0-.33-.328L1.1,12.67A1.692,1.692,0,0,1,.055,10.655l.053-.164.87-1.923a.564.564,0,0,0,0-.467L.151,6.283A1.692,1.692,0,0,1,.837,4.124l.193-.1L2.968,3.3a.565.565,0,0,0,.33-.33L4,1.1A1.692,1.692,0,0,1,6.012.055l.164.053L8.1.978a.565.565,0,0,0,.467,0L10.385.152a1.692,1.692,0,0,1,2.159.686Zm-1.478,4.6-4.025,4.6L5.575,8.567a.564.564,0,0,0-.8.8l1.894,1.894a.565.565,0,0,0,.823-.028l4.42-5.051a.564.564,0,0,0-.849-.743Z",
    fill: "#22ad7e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.827ddcbb6febd658b3f06da50e4fa057.svg";
export { ForwardRef as ReactComponent };